module.exports = __webpack_public_path__ + "static/media/deities4.d7f90635.jpg";